/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./json-group-item.vue?vue&type=template&id=72d3bd94&scoped=true&"
import script from "./json-group-item.vue?vue&type=script&lang=js&"
export * from "./json-group-item.vue?vue&type=script&lang=js&"
import style0 from "./json-group-item.vue?vue&type=style&index=0&id=72d3bd94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d3bd94",
  null
  
)

export default component.exports